import { SalesItemType, SalesItemTypeLabels } from '@navio/nsdk';
import type { NoddiIconName as IconName } from 'noddi-ui-common';
import { QuickFilterSpec, type FilterOption } from 'noddi-ui-web';
import { SALES_ITEM_TYPE_OPTIONS } from 'noddi-util';

/** Keep in sync with `SALES_ITEM_TYPE_ICON` in noddi-ui-web. */
const salesItemTypeIconMap: Record<SalesItemType, IconName> = {
  [SalesItemType.SERVICE]: 'Wrench',
  [SalesItemType.PRODUCT]: 'Package',
  [SalesItemType.FEE]: 'CircleDollarSign'
};

export const SALES_ITEM_TYPE_FILTER_OPTIONS: FilterOption<SalesItemType>[] = SALES_ITEM_TYPE_OPTIONS.map((opt) => ({
  ...opt,
  icon: salesItemTypeIconMap[opt.value]
}));

/** Title and description of this filter, for the builder next to `SALES_ITEM_TYPE_FILTER_OPTIONS`. */
export const SALES_ITEM_TYPE_FILTER_TEXT = {
  title: 'Type',
  description:
    'Service: on-site work (e.g. wheel change, mounting). Product: physical goods (e.g. tires, rims). Fee: non-service charges.'
};

/** The type tray, a `quickFilter` over the same `salesItemTypes` param as the sidebar facet. */
export const SALES_ITEM_TYPE_QUICK_FILTER: QuickFilterSpec<SalesItemType> = {
  label: 'Type',
  options: [
    { value: 'all', label: 'All' },
    { value: SalesItemType.FEE, label: SalesItemTypeLabels[SalesItemType.FEE], values: [SalesItemType.FEE] },
    {
      value: SalesItemType.PRODUCT,
      label: SalesItemTypeLabels[SalesItemType.PRODUCT],
      values: [SalesItemType.PRODUCT]
    },
    { value: SalesItemType.SERVICE, label: SalesItemTypeLabels[SalesItemType.SERVICE], values: [SalesItemType.SERVICE] }
  ]
};
